import { ApiConfig, HttpMethod, MICRO_SERVER_URL_CASE } from '../constant';

const URL_FEATURE_FLAG = `${MICRO_SERVER_URL_CASE}/tenant/feature/flag`;
const URL_GROUPS = `${MICRO_SERVER_URL_CASE}/aux/groups`;
const URL_TRACE_ACTIVE_AGENTS = `/cm/trace/active-agents`;
const URL_CASE_LICENCE = `/cm/tenant-config`;

export const featureFlag: ApiConfig = {
  url: `${URL_FEATURE_FLAG}`,
  cancelPrev: true,
};

export const groups: ApiConfig = {
  url: `${URL_GROUPS}`,
};

export const traceActiveAgents: ApiConfig = {
  url: `${URL_TRACE_ACTIVE_AGENTS}`,
  method: HttpMethod.POST,
  ignoreError: true,
};

export const caseLicence: ApiConfig = {
  url: `${URL_CASE_LICENCE}`,
};
